import actions from './action'

const initialState = {
  data: [],
  count: {},
  percentage: {},
  yearRecord: [],
}

const fetchRYGstatusEmpList = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_RYG_STATUS_DATA:
      return {
        ...state,
        data: action.payload,
      }
    case actions.FETCH_RYG_COUNT:
      return {
        ...state,
        count: action?.payload?.count,
        percentage: action?.payload?.percentages,
      }
    case actions.FETCH_RYG_YEAR_COUNT:
      return {
        ...state,
        yearRecord: action?.payload,
      }
    default:
      return state
  }
}

export default fetchRYGstatusEmpList
